import {environments} from './configs';
import {LANGUAGE_CODES} from '@chekin/core';

const IS_SDK_MODE = environments.VITE_APP_IS_SDK;
const APP_VARIANT = environments.VITE_APP_VARIANT;
const mockCallback = () => {};

class ChekinProSettings {
  static get settings() {
    return window.ChekinProSettings || {};
  }

  static get isSDK() {
    return IS_SDK_MODE ?? false;
  }

  static get appVariant() {
    return APP_VARIANT;
  }

  static get autoHeight() {
    return ChekinProSettings.settings.autoHeight ?? false;
  }

  static get apiKey() {
    return ChekinProSettings.settings.apiKey ?? '';
  }

  static get reservationId() {
    return ChekinProSettings.settings.reservationId;
  }

  static get housingId() {
    return ChekinProSettings.settings.housingId;
  }

  static get externalHousingId() {
    return ChekinProSettings.settings.externalHousingId;
  }

  static get guestId() {
    return ChekinProSettings.settings.guestId;
  }

  static get hideGuestsSummaryView() {
    return ChekinProSettings.settings.hideGuestsSummaryView;
  }

  static get externalReservationId() {
    return ChekinProSettings.settings.externalId;
  }

  static get defaultLanguage() {
    if (IS_SDK_MODE) {
      return (
        ChekinProSettings.settings.defaultLanguage ||
        environments.VITE_APP_DEFAULT_LANGUAGE ||
        LANGUAGE_CODES.en
      );
    }

    return undefined;
  }

  static get styles() {
    return ChekinProSettings.settings.styles;
  }

  static get prefillData() {
    return ChekinProSettings.settings.prefillData;
  }

  static get stylesLink() {
    return ChekinProSettings.settings.stylesLink;
  }

  static get externalId() {
    return ChekinProSettings.settings.externalId;
  }

  static get mode() {
    return ChekinProSettings.settings.mode;
  }

  static get canShareRegistrationLink() {
    if (IS_SDK_MODE) {
      return ChekinProSettings.settings.canShareRegistrationLink;
    }
    return true;
  }

  static get canEditReservationDetails() {
    if (IS_SDK_MODE) {
      return ChekinProSettings.settings.canEditReservationDetails;
    }
    return true;
  }

  static get isMobileModalModeAvailable() {
    if (IS_SDK_MODE) {
      return !ChekinProSettings.settings.autoHeight;
    }
    return true;
  }

  static get redirectIVQrUrl() {
    if (IS_SDK_MODE) {
      return ChekinProSettings.settings.redirectIVQrUrl;
    }
    return undefined;
  }

  static get enableGuestsRemoval() {
    if (IS_SDK_MODE) {
      return ChekinProSettings.settings.enableGuestsRemoval ?? false;
    }
    return false;
  }

  static get isLeader() {
    if (IS_SDK_MODE) {
      return ChekinProSettings.settings.isLeader;
    }
    return undefined;
  }

  static get events() {
    const settings = window.ChekinProSettings || {};

    return {
      onMounted: settings?.onMounted || mockCallback,
      onReservationFound: settings?.onReservationFound || mockCallback,
      onReservationCreated: settings?.onReservationCreated || mockCallback,
      onReservationFoundFromHousing:
        settings?.onReservationFoundFromHousing || mockCallback,
      onReservationFetched: settings?.onReservationFetched || mockCallback,
      onGuestRegistered: settings?.onGuestRegistered || mockCallback,
      onAllGuestsRegistered: settings?.onAllGuestsRegistered || mockCallback,
      onAllRequiredStepsCompleted: settings?.onAllRequiredStepsCompleted || mockCallback,
      onConnectionError: settings?.onConnectionError || mockCallback,
      onScreenChanged: settings?.onScreenChanged || mockCallback,
      onHeightChanged: settings?.onHeightChanged || mockCallback,
      onIVFinished: settings?.onIVFinished || mockCallback,
      onError: settings?.onError || mockCallback,
    };
  }

  static get hiddenSections() {
    if (IS_SDK_MODE) {
      return ChekinProSettings.settings.hiddenSections;
    }
    return undefined;
  }
}

export default ChekinProSettings;
